import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import api from '@/api';
import { NotFoundScreen } from '@/common/ErrorScreen';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import StudentFollowUpsTable from '@/tables/StudentFollowUpsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/follow-ups/entries',
)({
  component: MemberFollowUpsEntriesScreen,
});

function MemberFollowUpsEntriesScreen() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const studentId = Number(memberId);

  const { data: access, isLoading } = api.getStudentFollowUpsAccess.useQuery({
    path: { student_id: studentId },
  });

  if (isLoading) return null;
  if (access?.can_view !== true) return <NotFoundScreen />;

  return (
    <Container>
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('sidebar.follow-ups')} />
      </GroupHeaderWrapper>
      <StudentFollowUpsTable
        studentId={studentId}
        studentName={access.display_name ?? ''}
      />
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 40px;
`;
